<footer class="rodape">
  @if (sessaoAberta) {
    @if (mensagemResposta; as resposta) {
      <div class="rodape-resposta" @subir>
        <div class="rodape-resposta-conteudo">
          <span class="rodape-resposta-autor">Respondendo {{ resposta.sendBy === 'CLIENTE' ? (nomeContato || 'cliente') : 'você' }}</span>
          <span class="rodape-resposta-texto">{{ resumoResposta(resposta) }}</span>
        </div>
        <button type="button" class="rodape-btn-limpo rodape-btn-fechar-resposta" aria-label="Cancelar resposta" (click)="cancelarResposta.emit()">
          <img src="./assets/icones/redesign/utils/close.svg" alt="" />
        </button>
      </div>
    }

    @if (arquivos().length > 0) {
      <div class="rodape-anexos" @subir>
        @for (arquivo of arquivos(); track arquivo.file) {
          <div class="rodape-anexo" @pop [class.rodape-anexo-com-imagem]="arquivo.ehImagem && arquivo.preview" [title]="arquivo.file.name">
            @if (arquivo.ehImagem && arquivo.preview) {
              <img [src]="arquivo.preview" alt="" class="rodape-anexo-imagem" />
            } @else {
              <span class="chat-tipo-arquivo rodape-anexo-icone" [style.border-color]="infoDoArquivo(arquivo.file).cor"
                    [matTooltip]="infoDoArquivo(arquivo.file).rotulo">
                <img [src]="infoDoArquivo(arquivo.file).icone" [alt]="infoDoArquivo(arquivo.file).rotulo" />
              </span>
              <span class="rodape-anexo-nome">{{ arquivo.file.name }}</span>
            }
            <button type="button" class="rodape-anexo-remover" aria-label="Remover anexo" (click)="removerArquivo($index)">
              <img src="./assets/icones/redesign/utils/close.svg" alt="" />
            </button>
          </div>
        }
        <button type="button" class="rodape-anexo rodape-anexo-adicionar" aria-label="Adicionar mais arquivos" (click)="abrirSeletorArquivo()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    }

    @if (gravando()) {
      <div class="rodape-linha rodape-gravacao" @subir>
        <button type="button" class="rodape-btn-limpo rodape-btn-lixeira" aria-label="Descartar áudio" (click)="descartarGravacao()">
          <img src="./assets/icones/redesign/modulos/chat/components-message/audio-lixeira.svg" alt="" />
        </button>

        @if (gravador.estado() === 'pausado' && gravador.urlPrevia(); as url) {
          <div class="rodape-gravacao-painel rodape-gravacao-painel-previa" @surgir>
            <app-player-audio class="rodape-previa-player" [src]="url"></app-player-audio>
          </div>
        } @else {
          <div class="rodape-gravacao-painel">
            <span class="rodape-gravacao-bolinha" [class.rodape-gravacao-bolinha-pausada]="gravador.estado() === 'pausado'"></span>
            <span class="rodape-gravacao-tempo">{{ tempoGravacao() }}</span>
            <div class="rodape-gravacao-onda" [class.rodape-gravacao-onda-pausada]="gravador.estado() === 'pausado'">
              @for (nivel of gravador.niveis(); track $index) {
                <span class="rodape-gravacao-barra" [style.height.%]="nivel * 100"></span>
              }
            </div>
          </div>
        }

        <button type="button" class="rodape-btn-limpo rodape-btn-pausa"
                [attr.aria-label]="gravador.estado() === 'gravando' ? 'Pausar gravação' : 'Continuar gravando'"
                (click)="pausarOuRetomar()">
          @if (gravador.estado() === 'gravando') {
            <img src="./assets/icones/redesign/modulos/chat/components-message/audio-pausar.svg" alt="" />
          } @else {
            <img src="./assets/icones/redesign/modulos/chat/components-message/Mic.svg" alt="" class="rodape-mic-retomar" />
          }
        </button>

        <button type="button" class="rodape-btn-enviar" aria-label="Enviar áudio" (click)="enviarGravacao()">
          <img src="./assets/icones/redesign/modulos/chat/components-message/send-tempalte.svg" alt="" />
        </button>
      </div>
    } @else {
      <div class="rodape-linha">
        <div class="rodape-campo" [class.rodape-campo-bloqueado]="!podeEnviar">
          @if (!bloqueado) {
            <button type="button" class="rodape-btn-limpo" aria-label="Anexar arquivo" [disabled]="carregando" (click)="abrirSeletorArquivo()">
              <img src="./assets/icones/redesign/modulos/chat/components-message/attach-file.svg" alt="" />
            </button>
            <button type="button" class="rodape-btn-limpo rodape-btn-emoji" [class.rodape-btn-emoji-ativo]="emojiAberto()" aria-label="Emojis"
                    [disabled]="carregando || !podeEnviar" (click)="alternarEmoji()">
              <img src="./assets/icones/redesign/modulos/chat/components-message/emoji.svg" alt="" />
            </button>
          }
          <textarea
            #campoTexto
            rows="1"
            class="rodape-textarea"
            [placeholder]="podeEnviar ? 'Comece a digitar aqui...' : (motivoBloqueio || 'Aguarde o cliente responder...')"
            [disabled]="carregando || !podeEnviar"
            [(ngModel)]="texto"
            (ngModelChange)="aoDigitar()"
            (keydown)="aoPressionarTecla($event)"
            (keyup)="lembrarCursor()"
            (click)="lembrarCursor()"
            (blur)="lembrarCursor()"
            (paste)="aoColar($event)"
          ></textarea>
          <input #inputArquivo type="file" multiple class="rodape-input-arquivo" [accept]="acceptArquivos" (change)="aoSelecionarArquivos($event)" />
        </div>

        @if (!bloqueado) {
          @if (!temConteudo) {
            <button type="button" class="rodape-btn-limpo rodape-btn-mic" @surgir aria-label="Gravar áudio" [disabled]="carregando" (click)="iniciarGravacao()">
              <img src="./assets/icones/redesign/modulos/chat/components-message/Mic.svg" alt="" />
            </button>
          }

          <button type="button" class="rodape-btn-enviar" [class.rodape-btn-enviar-pronto]="temConteudo && podeEnviar" aria-label="Enviar mensagem"
                  [disabled]="carregando || !podeEnviar || !temConteudo" (click)="enviar()">
            <img src="./assets/icones/redesign/modulos/chat/components-message/send-tempalte.svg" alt="" />
          </button>
        }
      </div>

      @if (emojiAberto()) {
        <div class="rodape-emoji-picker" @pop>
          <emoji-mart
            [isNative]="true"
            [darkMode]="false"
            [showPreview]="false"
            [enableSearch]="true"
            [perLine]="9"
            [emojiSize]="26"
            [color]="'#993DF5'"
            [i18n]="i18nEmoji"
            [emojiTooltip]="false"
            (emojiSelect)="adicionarEmoji($event)"
          ></emoji-mart>
        </div>
      }
    }
  } @else if (ehInstagram) {
    <div class="rodape-linha">
      <div class="rodape-campo rodape-campo-bloqueado">
        <textarea rows="1" class="rodape-textarea" disabled
                  placeholder="Sessão do Instagram encerrada. Aguarde o contato enviar uma nova mensagem."></textarea>
      </div>
    </div>
  } @else {
    <div class="rodape-linha">
      <button type="button" class="rodape-campo rodape-template-toggle" [disabled]="carregando" (click)="abrirTemplates.emit()">
        <img src="./assets/icones/redesign/modulos/chat/sessao-closed-not-msg.svg" alt="" class="rodape-template-icone" />
        <span class="rodape-template-valor rodape-template-placeholder">Selecione um template...</span>
        <mat-icon class="rodape-template-seta">expand_more</mat-icon>
      </button>

      <button type="button" class="rodape-btn-enviar" aria-label="Selecionar template" [disabled]="carregando" (click)="abrirTemplates.emit()">
        <img src="./assets/icones/redesign/modulos/chat/components-message/send-tempalte.svg" alt="" />
      </button>
    </div>
  }
</footer>
